module.exports = __webpack_public_path__ + "img/text.321b25c5.png";